import {
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  inject,
  input,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { DatePicker } from 'primeng/datepicker';
import { InputText } from 'primeng/inputtext';
import { Paginator } from 'primeng/paginator';
import { Select } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { Tooltip } from 'primeng/tooltip';
import { TableBaseAbstractComponent } from '../../../../../../../shared/components/table-base-abstract.component';
import { UserEventObject } from '../../../../../../../shared/enums/user-event-object.enum';
import { UserEventFilterType } from '../../../../../../../shared/enums/user-event-filter-type.enum';
import { AdminPanelUserDetails } from '../../../../../../../shared/models/admin-panel-user-details';
import { AdminPanelUserHistoryEntry } from '../../../../../../../shared/models/admin-panel-user-history-entry';
import { TableRequestData } from '../../../../../../../shared/models/table/table-request-param';
import { TableResponse } from '../../../../../../../shared/models/table-response';
import { AdminPanelUsersApi } from '../../../../../../../shared/services/api/admin-panel-users.api';
import { ConstLabelReaderPipe } from '../../../../../../../shared/pipes/const-label-reader.pipe';
import { UserEventBusinessLabelPipe } from '../../../../../../../shared/pipes/user-event-business-label.pipe';
import { DialogService } from 'primeng/dynamicdialog';
import { AdminPanelUserEventDetailsDialogComponent } from '../admin-panel-user-event-details-dialog/admin-panel-user-event-details-dialog.component';

@Component({
  selector: 'app-admin-panel-user-events-history-table',
  imports: [
    Button,
    Card,
    ConstLabelReaderPipe,
    DatePicker,
    FormsModule,
    InputText,
    Paginator,
    Select,
    TableModule,
    DatePipe,
    Tooltip,
    UserEventBusinessLabelPipe,
  ],
  templateUrl:
    './admin-panel-user-events-history-table.component.html',
  styleUrl: './admin-panel-user-events-history-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserEventsHistoryTableComponent extends TableBaseAbstractComponent<AdminPanelUserHistoryEntry> {
  @ViewChild('table') override tableRef!: Table;

  readonly #adminPanelUsersApi = inject(AdminPanelUsersApi);
  readonly #dialogService = inject(DialogService);

  userDetails = input.required<AdminPanelUserDetails>();

  protected readonly USER_EVENT_FILTER_TYPE = UserEventFilterType;
  protected readonly USER_EVENT_OBJECT = UserEventObject;
  protected readonly eventObjectOptions = Object.entries(UserEventObject).map(
    ([key, value]) => ({
      label: value,
      value: key,
    }),
  );


  protected readonly eventTypeOptions = Object.entries(UserEventFilterType).map(
    ([key, value]) => ({
      label: value,
      value: key,
    }),
  );

  protected tableFilters = {
    eventDate: null as Date | null,
    eventObject: null as keyof typeof UserEventObject | null,
    eventType: null as keyof typeof UserEventFilterType | null,
    eventAuthor: '',
  };

  constructor() {
    super();
    this.tableRequest.update((value) => ({
      ...value,
      pageSize: 10,
    }));
  }

  protected override apiCall$ = (
    params: TableRequestData,
  ): Observable<TableResponse<AdminPanelUserHistoryEntry>> => {
    return this.#adminPanelUsersApi.getUserEventsHistory$(
      this.userDetails(),
      params,
    );
  };

  protected showDetails(entry: AdminPanelUserHistoryEntry): void {
    this.#dialogService.open(AdminPanelUserEventDetailsDialogComponent, {
      header: 'Podgląd zdarzenia użytkownika',
      closable: true,
      modal: true,
      closeOnEscape: true,
      dismissableMask: true,
      width: '900px',
      breakpoints: {
        '960px': '90vw',
        '640px': '90vw',
      },
      inputValues: {
        event: entry,
      },
    });
  }

  protected onFilterChangeMobile(
    target: EventTarget | null,
    field: string,
  ): void {
    this.onPrimeFilterChangeMobile(target as any, field);
  }

  protected clearFilters(): void {
    this.tableFilters = {
      eventDate: null,
      eventObject: null,
      eventType: null,
      eventAuthor: '',
    };
    this.resetFilters();
  }
}
